























import { Component, Vue } from 'vue-property-decorator';

import EventDTO from '@/api/dto/EventDTO';
import ITier from '@/api/interface/ITier';
import SponsorDTO from '@/api/dto/SponsorDTO';
import ApiUtils from '@/api/util/ApiUtils';
import TypeUtils from '@/api/util/TypeUtils';
import BaseVue from '@/api/core/BaseVue';
import FormatUtils from '@/api/util/FormatUtils';
import TemplateOne from '@/components/EventPageTemplates/template1.vue';
import TemplateTwo from '@/components/EventPageTemplates/template2.vue';
import LoadingIcon from '@/components/LoadingIcon.vue';
import VueAnalytics from 'vue-analytics';
import { EMBED_SCRIPT_ID } from '@/api/EventConstants';

@Component({
  components: {
    LoadingIcon,
    TemplateOne,
    TemplateTwo,
  },
})
export default class EventPage extends BaseVue {
  public event: any = {};
  public isEventInactive: boolean = false;
  public posterVideoURL: string | undefined = '';
  private tiers: ITier[] = [];
  private loading: boolean = true;

  private created() {
    if (this.api === null) {
      return;
    }
    const isPreview = this.$route.query.preview === '1';

    this.api
      .getEvent(this.$route.params.eventSlug, isPreview)
      .then((res) => {
        const eventUpdate = this.handleSuccessIgnoreError(res, 'data.event');
        this.event = EventDTO.toPreview(
          eventUpdate,
          eventUpdate.ticketDefinitions,
        );
        this.isEventInactive = EventDTO.isEventInactive(eventUpdate);
        this.posterVideoURL = FormatUtils.parseVideoURL(this.event.posterUrl);

        if (this.event.embed && this.event.embed.type !== 'giving_form') {
          // Logic for injecting legacy embed script.
          // For 2.0 forms, see DonationEmbed.vue mounted()
          if (document.getElementById(EMBED_SCRIPT_ID) === null) {
            const embedScript = document.createElement('script');
            embedScript.setAttribute(
              'src',
              this.$store.getters.embed.scriptUrl,
            );
            embedScript.setAttribute('id', EMBED_SCRIPT_ID);
            document.head.appendChild(embedScript);
          }
        }

        if (this.event.googleAnalyticsKey) {
          Vue.use(VueAnalytics, {
            id: this.event.googleAnalyticsKey,
          });
          this.$ga.page({
            page: this.$route.params.eventSlug,
            title: this.event.name,
            location: window.location.href,
          });
        }
      })
      .then(() => {
        this.loading = false;
      });

    this.api
      .getSponsors(this.$route.params.eventSlug, isPreview)
      .then((res) => {
        const event = this.handleSuccessIgnoreError(
          res,
          'data.event.sponsorTiers',
        );
        this.tiers = SponsorDTO.fromModel(event);
      })
      .catch(this.handleFailure);
  }
}
